import React from 'react';
import { Button, LoadIndicator } from 'devextreme-react';
import PopupMVP from '../../PopupMVP';

export const Popup = ({
  open,
  onClose,
  title,
  onAction,
  loading,
  children,
  actionBtnTitle = 'Применить',
  cancelBtnTitle = 'Отмена'
}) => {
  const handleAction = () => {
    if (onAction) onAction();
    if (onClose) onClose();
  };

  return (
    <PopupMVP visible={open} onHiding={onClose} title={title}>
      <div className="formData">
        {children}
        <Actions
          onAction={handleAction}
          onCancel={onClose}
          loading={loading}
          actionTitle={actionBtnTitle}
          cancelTitle={cancelBtnTitle}
        />
      </div>
    </PopupMVP>
  );
};

const Actions = ({ onAction, onCancel, loading, actionTitle, cancelTitle }) => (
  <div className="formButton">
    <Button
      text={cancelTitle}
      type="default"
      stylingMode="text"
      onClick={onCancel}
    />
    <Button
      text={actionTitle}
      type="default"
      stylingMode="contained"
      onClick={onAction}
      width={200}
    >
      <LoadIndicator className="indicator" visible={loading} />
      <span>{actionTitle}</span>
    </Button>
  </div>
);
